import { SidebarModal } from '@domain-group/suit-theme'

import { snakeToTitleCase } from '@domain-group/javascript-utils'

import { useRelations as useTeamMemberRelations } from '@hooks/useTeamMember'
import { useRelations as useUserRelations } from '@hooks/useUser'

import type { TeamMemberModel } from '@models/types'

const TeamMemberListItem = (props: { teamMember: TeamMemberModel }) => {
  const { teamMember } = props

  const { user } = useTeamMemberRelations(teamMember)
  const { image } = useUserRelations(user)

  return (
    <SidebarModal.User
      disableHover
      // @ts-expect-error TS2339
      imageUrl={image.square_url}
      subtitle={snakeToTitleCase(teamMember?.member_role)}
      // @ts-expect-error TS2339
      title={user?.full_name}
    />
  )
}

export default TeamMemberListItem
